import { startOfUtcMonth } from "@/lib/date-utils"

/** How many months back from the current month users may navigate. */
export const MONTHS_BACK = 3

function parseUtcCalendar(date = new Date()) {
  return {
    year: date.getUTCFullYear(),
    monthIndex: date.getUTCMonth(),
  }
}

function utcMonthStart(year: number, monthIndex: number): Date {
  return new Date(Date.UTC(year, monthIndex, 1))
}

function monthStamp(date: Date) {
  const { year, monthIndex } = parseUtcCalendar(date)
  return year * 12 + monthIndex
}

export function getMonthBounds(now = new Date()) {
  const { year, monthIndex } = parseUtcCalendar(now)
  return {
    maxMonth: utcMonthStart(year, monthIndex),
    minMonth: utcMonthStart(year, monthIndex - MONTHS_BACK),
  }
}

export function isAtMinMonth(month: Date, now = new Date()) {
  const { minMonth } = getMonthBounds(now)
  return monthStamp(month) === monthStamp(minMonth)
}

export function isAtMaxMonth(month: Date, now = new Date()) {
  const { maxMonth } = getMonthBounds(now)
  return monthStamp(month) === monthStamp(maxMonth)
}

export function clampMonth(month: Date, now = new Date()) {
  const { minMonth, maxMonth } = getMonthBounds(now)
  const normalized = startOfUtcMonth(month)
  const value = monthStamp(normalized)
  const min = monthStamp(minMonth)
  const max = monthStamp(maxMonth)
  if (value < min) return new Date(minMonth)
  if (value > max) return new Date(maxMonth)
  return normalized
}
